<template>
  <div>
    <v-btn class="ma-0" x-large rounded color="warning" dark @click="$store.state.dataFrm.tea_card_id==''?checkLogin():$router.push({path:'/resume'})">
      <v-avatar size="38" class="mr-4">
        <img :src="person_photo" alt="John"
      /></v-avatar>
       {{$store.state.dataFrm.tea_card_id!=''?$store.state.dataFrm.tea_card_id:'เข้าสู่ระบบ'}}
    </v-btn>
    <Login @callBack="callBack_Signin"></Login>
  </div>
</template>

<script>
import Login from "../components/login";
var noProfile = require('@/assets/images/noProfile.jpg');
export default {
  components: { Login },
  data: () => ({
    person_photo:noProfile
  }),

  methods: {
    checkLogin() {
      if (this.$store.state.resumeOnce == null) {
        this.$store.state.statShowFrmLogin = true;
      } else {
        this.$store.state.statShowFrmLogin = false;
      }
    },
    callBack_Signin() {
        this.$store.state.statShowFrmLogin = false;
    },
  },
};
</script>
